import { useMemo } from 'react';
import PhotoAPI from '@/services/photo-api';
import { type IEmbedUomArticle } from '@/types/IEmbeds';
import { type TEmbedArticles } from '@/types/INote';
import styles from './index.module.scss';

const ContentTypeMap: Record<Lowercase<TEmbedArticles[number]['contentType']>, string> = {
  '': '',
  analiza: 'Analiza',
  gwiazdypisza: 'Gwiazdy piszą',
  historia: 'Historia',
  nazywo: 'Na żywo',
  opinia: 'Opinia',
  recenzja: 'Recenzja',
  reportaz: 'Reportaż',
  sportplus: 'Sport.pl +',
  sprawdzam: 'Sprawdzam',
  testujemy: 'Testujemy',
  tylkounas: 'Tylko u nas',
  waszglos: 'Wasz głos',
  wywiad: 'Wywiad',
} as const;

export default function UomArticleRelated ({ embedArticle }: { embedArticle: TEmbedArticles[number] } & IEmbedUomArticle) {
  const data = useMemo(() => {
    return {
      businessLabel: embedArticle.businessType || (embedArticle.subscription && 'subskrypcja') || undefined,
      hasBusinessType: Boolean(embedArticle.businessType),
      mainImage: PhotoAPI.photoFromUrl(embedArticle.mainImage, 'II'),
      title: embedArticle.title,
      titlePrefix: embedArticle.serviceBrandLabel || ContentTypeMap[embedArticle.contentType.toLowerCase() as keyof typeof ContentTypeMap] || undefined,
      url: embedArticle.url,
    };
  }, [embedArticle]);

  if (data.title.length === 0 || data.url.length === 0) {
    return null;
  }

  return (
    <a
      className={styles['uom-article']}
      data-bd-viewability='1'
      data-bd-viewability-href={data.url}
      data-bd-viewability-id='art_related'
      href={data.url}
      title={data.title}
    >
      {data.mainImage ? <img alt={data.title} className={styles['uom-article__image']} src={`${data.mainImage}#e=RelArtImg(1)`} /> : <div className={styles['uom-article__image']} />}
      <div className={styles['uom-article__meta']}>
        <span className={styles['uom-article__title']} data-title-prefix={!data.hasBusinessType ? data.titlePrefix : undefined}>{data.title}</span>
        {data.businessLabel ? <span className={styles['uom-article__business-type']}>{data.businessLabel}</span> : null}
      </div>
    </a>
  );
}
